import AppointmentEvent from "./AppointmentEvent";

export default AppointmentEvent;